import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';
import * as CategoriesActions from './categories.actions';

export const categoriesFeatureKey = 'categories';

export interface State extends EntityState<any> {
  selected: any;
}

export const adapter: EntityAdapter<any> = createEntityAdapter<any>({
  selectId: (category: any) => category.categoryId,
});

export const initialState: State = adapter.getInitialState({
  selected: null
});


export const reducer = createReducer(
  initialState,

  on(CategoriesActions.LoadCategories, state => state),
  on(CategoriesActions.LoadCategoriessSucces, (state, action) => {
    return adapter.upsertMany(action.data, state);
  }),
  on(CategoriesActions.LoadCategoriesFailure, (state, action) => state),

  on(CategoriesActions.SelectCategory, (state, { payload: selected }) => {
    return { ...state, selected };
  })

);

